export default __webpack_public_path__ + "static/media/icon_chat.07f95cbc.png";